import React from "react";
import styled from "styled-components";
import { COLOR_L_PRIMARY, COLOR_PRIMARY } from "../../utils/colors";

export default function InputSwitchComponent({
  label,
  name,
  options = [],
  value,
  onChange,
  disabled = false,
  touches = false,
}) {
  const options_total = options.length;
  return (
    <>
      {label && (
        <label
          htmlFor=""
          className={`text-sm-label editLabelForm text-bold my-1 ${
            label == "-" ? "invisible" : ""
          }`}
          style={{
            fontSize: 14,
            lineHeight: "23px",
          }}
        >
          {label}
          {/* {label} {disabled && Lock_svg()} */}
        </label>
      )}
      <InputSwitchComponentStyled>
        {options.map((d, idx) => (
          <div
            key={`${idx}_${d.value}`}
            className={`block ${
              d.value == value ? "active" : ""
            } cursor-pointer ${!value ? "extra_border" : ""} ${
              options_total > 2
                ? idx + 1 > 1 && idx + 1 < options_total
                  ? "extra_border"
                  : ""
                : ""
            } ${touches ? (idx == 0 ? "touches" : "") : ""}`}
            onClick={
              disabled
                ? () => console.log("DISABLED")
                : () => {
                    onChange({ target: { name, value: d.value } });
                  }
            }
          >
            {d.label}
          </div>
        ))}
      </InputSwitchComponentStyled>
    </>
  );
}

const InputSwitchComponentStyled = styled.div`
  display: flex;
  .block:first-child {
    border-radius: 2px 0px 0px 2px;
    border-width: 1px 0px 1px 1px;
  }
  .block.touches {
    border-radius: 0px 0px 0px 0px;
  }
  .block:last-child {
    border-width: 1px 1px 1px 0px;
    border-radius: 0px 2px 2px 0px;
  }
  .block {
    flex: 1;
    padding: 9.5px 10px;
    border-width: 1px 0px 1px 0px;
    border-style: solid;
    border-color: #d9d9d9;
    background: #fcfcfc;
    font-weight: 600;
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    &.extra_border {
      border-width: 1px;
    }
    &.active {
      border-width: 1px;
      border-color: ${COLOR_PRIMARY};
      background: ${COLOR_L_PRIMARY};
      color: ${COLOR_PRIMARY};
    }
  }
`;
